import { render } from "./PricingEdit.vue?vue&type=template&id=5c30fa4e"
import script from "./PricingEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Pricing/PricingEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c30fa4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c30fa4e', __exports__)) {
    api.reload('5c30fa4e', __exports__)
  }
  
  module.hot.accept("./PricingEdit.vue?vue&type=template&id=5c30fa4e", () => {
    api.rerender('5c30fa4e', render)
  })

}


export default __exports__